import { FC, useEffect } from "react";
import { Col, Form, FormGroup, Label, Row } from "reactstrap";
import ModalComponent from "../../shared/base-components/Modal";
import { SubmitHandler, useForm } from "react-hook-form";
import Button from "../../shared/base-components/Button";

import { UseMutateFunction } from "@tanstack/react-query";
import { AxiosError } from "axios";
import { successNotify } from "../../shared/utils/notifications";
import { SmsResponse } from "./Company.constants";
import TextField from "../../shared/base-components/TextField";
import { useSmsCreateMutation, useSmsUpdateMutation } from "./Company.actions";

interface CustomerMaintanenceSmsModalProps {
  isModalOpen: boolean;
  toggle: () => void;
  smsData: SmsResponse | undefined;
  mutate: UseMutateFunction<SmsResponse, AxiosError<any>, any, unknown>;
}

const CustomerMaintanenceSmsModal: FC<CustomerMaintanenceSmsModalProps> = ({
  isModalOpen,
  toggle,
  smsData,
  mutate,
}) => {
  const {
    data: smsCreateData,
    mutate: smsCreateMutate,
    isLoading,
  } = useSmsCreateMutation();

  const {
    data: smsUpdateData,
    mutate: smsUpdateMutate,
    isLoading: smsUpdateLoading,
  } = useSmsUpdateMutation();

  const {
    control,
    handleSubmit,
    formState: { errors },
  } = useForm<any>();

  const maintenanceSms = smsData?.find(
    (item) => item.content_type === "maintenance"
  );

  const onSubmit: SubmitHandler<any> = (requestFormValues) => {
    maintenanceSms?.content.length
      ? smsUpdateMutate({
          smsId: maintenanceSms.id,
          content: requestFormValues.sms,
          custom_title: "maintenance",
          content_type: "maintenance",
        })
      : smsCreateMutate({
          content_type: "maintenance",
          content: requestFormValues.sms,
          custom_title: "maintenance",
        });
  };

  useEffect(() => {
    if (smsCreateData?.content.length || smsUpdateData?.content.length) {
      mutate({});
      successNotify("Güncelleme başarılı!");
      toggle();
    }
  }, [smsCreateData, smsUpdateData]);

  return (
    <ModalComponent
      header="Bakım Sms Güncelleme"
      description="Bakım Sms güncellemek için gerekli alanları doldurunuz."
      isOpen={isModalOpen}
      toggle={toggle}
    >
      <Form onSubmit={handleSubmit(onSubmit)} className="custom-form mt-4 pt-2">
        <Row>
          <Col sm="12" md="12" lg="12">
            <TextField
              control={control}
              type="textarea"
              name="sms"
              defaultValue={
                maintenanceSms?.content.length
                  ? maintenanceSms?.content
                  : `Değerli Müşterimiz, Su Arıtma Cihazınızın bakım zamanı gelmiştir. En yakın zamanda bizimle iletişime geçmenizi önemle rica ediyoruz.`
              }
            />
          </Col>

          <Col md="12">
            <FormGroup className="mb-3">
              <Button
                loading={isLoading}
                text="Bakım Sms Güncelle"
                variant="primary"
              />
            </FormGroup>
          </Col>
        </Row>
      </Form>
    </ModalComponent>
  );
};

export default CustomerMaintanenceSmsModal;
